export default __webpack_public_path__ + "static/media/LittleStars.9e94edef.svg";